export enum EnumHint {
    Numbers = 0,
    Date = 1,
    Hour = 2,
    Calc = 3,
    Separator = 4,
    ScoreBoard = 5,
    Kg = 6,
    HourResult = 7,
    ControleSecagemExemplo = 8,
    SecadorCamaraExemplo = 9,
    LoteRw = 10,
    Safra = 11,
    LoteDs = 12,
    SiloDestino = 13,
    SiteCdr = 14,
    CalcTipoTrat = 15,
    SafraLabel = 16,
    RecobrRolos = 17,
    LinhaDescarga = 18,
    DropDownList = 19,
    ControlesGerados = 20,
    LoteOrigem = 21,
    loteTb = 22,
    SafraPreBasica = 23,
    SafraPreBasicaLabel = 24,
    LoteDsPet = 25
}
